<!--新版本结算中心-->
<!--先判断是否已经绑定银行卡，然后再判断是否达到提现门槛-->
<template>
  <div class="wrapdraw-wrapper">
    <div class="wrapdraw-box">
      <div class="content-wrap">
        <div class="content">
          <img src="@/assets/images/minibean.png" class="imgPic" />
          <div class="desc1">迷你豆</div>
          <div class="mValue1">
            <span class="value1">{{ minibean }} </span>
            <span class="bean">豆</span>
          </div>
        </div>
        <!--迷你豆提现-->
        <div class="bind">
          <el-row class="button1" v-if="canMinibean">
            <el-button type="warning" @click="getMinibean">
              提取到游戏</el-button
            >
          </el-row>
          <el-row class="button2" v-else>
            <el-button type="warning" disabled>提取到游戏</el-button>
            <!-- <el-button plain disabled v-else>提现</el-button> -->
          </el-row>
        </div>
      </div>

      <!-- <div class="intro">每月额度{{ minibean_month_max }}</div> -->
      <!--二期先屏蔽额度限制-->
      <div class="intro"><br /></div>
    </div>
    <!--工作室结算-->
    <div class="settlement-box">
      <div class="all-title" v-if="settleArr.length">待结算金额</div>

      <div
        class="settlement-wrap"
        v-for="(item, index) in settleArr"
        :key="index"
      >
        <div class="content-wrap">
          <div class="content">
            <div class="desc">账单金额：</div>
            <div class="mValue">
              <span class="value1">{{ item.money }} </span>元
            </div>
          </div>
          <!--判断是否绑定银行卡-->
          <!-- <div class="bind" v-if="binding">
          <el-row class="button1">
            <el-button plain v-if="canWithdraw" @click="getMoney"
              >提现</el-button
            >
            <el-button plain disabled v-else>提现</el-button>
          </el-row>
        </div>
        <span class="bind" v-else>
          <el-row class="button1">
            <el-button plain>绑定银行卡</el-button>
          </el-row>
        </span> -->
        </div>
        <div class="settle-description" v-if="item.state === 5">
          <span class="label"><span class="label-content"> </span></span>
          <span class="content">
            发票结算单审核未通过，平台将在2个工作日回退邮件。退回原因：
            <span>{{ item.inviice_audit_remarks }}。</span>
          </span>
        </div>
        <div class="withdraw-step">
          <div class="step-wrap">
            <!--确认账单金额-->
            <div class="steps">
              <div
                :class="[
                  item.state > 1 || item.state == 1
                    ? 'active steps-label'
                    : 'steps-label',
                ]"
              >
                <div class="label">
                  <div class="label-content"></div>
                </div>
                <div class="step-line"></div>
              </div>
              <div class="step-content">
                <div class="content">{{ stepArr[0].content }}</div>
                <div class="date" v-if="item.create_time">
                  {{ item.create_time | regroupDate }}
                </div>
                <div class="date1" v-else>
                  {{ description1 }}
                </div>
              </div>
            </div>
            <!--邮寄发票-->
            <div class="steps">
              <div
                :class="[
                  item.state > 2 || item.state === 2
                    ? 'active steps-label'
                    : 'steps-label',
                ]"
              >
                <div class="label">
                  <div class="label-content"></div>
                </div>
                <div class="step-line"></div>
              </div>
              <div class="step-content">
                <div class="content">{{ stepArr[1].content }}</div>
                <div class="date" v-if="item.invoice_send_time">
                  {{ item.invoice_send_time | regroupDate }}
                </div>
                <div class="date2" v-else>
                  {{ item.state === 1 ? '待寄送' : '' }}
                </div>
              </div>
            </div>
            <!--平台签收-->
            <div class="steps">
              <div
                :class="[
                  item.state > 3 || item.state === 3
                    ? 'active steps-label'
                    : 'steps-label',
                ]"
              >
                <div class="label">
                  <div class="label-content"></div>
                </div>
                <div class="step-line"></div>
              </div>
              <div class="step-content">
                <div class="content">{{ stepArr[2].content }}</div>
                <div class="date" v-if="item.invoice_rece_time">
                  {{ item.invoice_rece_time | regroupDate }}
                </div>
                <div class="date3" v-else>
                  {{ item.state === 2 ? '待签收' : '' }}
                </div>
              </div>
            </div>
            <!--平台审核-->
            <div class="steps">
              <!--判断是否审核失败-->
              <div
                v-if="item.state !== 5"
                :class="[
                  (item.state > 4 && item.state != 5) || item.state === 4
                    ? 'active steps-label'
                    : 'steps-label',
                ]"
              >
                <div class="label">
                  <div class="label-content"></div>
                </div>
                <div class="step-line"></div>
              </div>
              <div class="fail steps-label" v-else>
                <div class="label">
                  <div class="label-content"></div>
                </div>
                <div class="step-line"></div>
              </div>
              <!--审核失败-->
              <div class="step-content" v-if="item.state === 5">
                <div class="content">{{ stepArr[3].content }}</div>
                <div class="content-fail">未通过</div>
              </div>
              <div class="step-content" v-else>
                <div class="content">{{ stepArr[3].content }}</div>
                <div class="date" v-if="item.invoice_audit_time">
                  {{ item.invoice_audit_time | regroupDate }}
                </div>
                <div class="date3" v-else>
                  {{ item.state === 3 ? '待审核' : '' }}
                </div>
              </div>
            </div>
            <!--打款完成-->
            <div class="steps">
              <div
                :class="[
                  item.state === 6 || (item.state === 8 && item.state !== 7)
                    ? 'active steps-label'
                    : 'steps-label',
                ]"
              >
                <div class="label">
                  <div class="label-content"></div>
                </div>
              </div>
              <div class="step-content">
                <div class="content">{{ stepArr[4].content }}</div>
                <div class="date" v-if="item.pay_time">
                  {{ item.pay_time | regroupDate }}
                </div>
                <div class="date3" v-else>
                  {{ item.state === 4 ? '待打款' : '' }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="submit-step">
          <div class="button1" v-if="item.state" @click="downloadBill">
            下载结算单
          </div>
          <div class="button1" @click="clickStep(item.id)">查看明细</div>
          <div
            class="button2"
            @click="changeStep(item.money, item.create_time)"
            v-if="item.id === 0"
          >
            确认金额
          </div>
          <div
            class="button2"
            v-if="item.state === 1"
            @click="sendCommit(item.id, item.create_time)"
          >
            寄送确认
          </div>
          <div
            class="button2"
            v-if="item.state === 5"
            @click="sendGinCommit(item.id)"
          >
            重新发起流程
          </div>
          <div
            class="button2"
            v-if="item.state === 6"
            @click="closeCommit(item.id)"
          >
            完成
          </div>
        </div>
      </div>
      <!--分页-->
      <div class="data-filter" v-if="settleArr.length">
        <el-pagination
          background
          layout="prev,pager,next,jumper"
          :total="totalCount"
          :page-size="pagePagination.page_size"
          @current-change="PageChange"
        >
          <!-- :hide-on-single-page="true" -->
        </el-pagination>
      </div>
      <div class="intro-wrap">
        <div class="title">结算说明</div>
        <div class="desc">
          1.
          当月的收益数据平台会在N+2月1日确认，迷你豆直接到账。现金收益将生成一条对公结算单，需要工作室室长确认账单金额并邮寄发票与结算单，平台审核通过后会直接打款到对公账户内。
        </div>
        <div class="desc">
          2.
          点击查看明细，可以看到该条结算单的收益来源及折算金额。备注：历史未提现的金额在2月28日上线的版本统一折算成一条对公结算单，统一记为2022-1-1日前折算收益。如有疑问请咨询客服。
        </div>
        <div class="desc">
          3. 迷你豆可以提取到游戏之中，目前暂不限制每月额度。
        </div>
        <div class="desc">
          4.
          若本月的待结算单没有确认，次月新结算单将会自动折叠。查看明细仍保留相应收益记录。
        </div>
        <div class="desc">5. 单笔对公打款金额需大于1000元。</div>
        <!-- <div class="desc-bottom">
          查询具体详情
          <a href="https://dev-wiki.mini1.cn/news/2069" target="_blank"
            >https://dev-wiki.mini1.cn/news/2069</a
          >
        </div> -->
      </div>
    </div>
    <!--迷你豆提现弹窗-->
    <form-dialog
      :showWithdrawForm="showWithdrawForm1"
      :withdrawInfo="withdrawInfo"
      @closeWithdrawForm="closeWithdrawForm"
    >
    </form-dialog>
    <!--查看明细弹框-->
    <el-dialog
      :visible.sync="detailVisible"
      width="770px"
      title="结算单明细"
      :show-close="false"
      :close-on-click-modal="false"
      class="detail-dialog"
    >
      <div class="detail-content">
        <div class="detail-box">
          <div
            class="detail-wrap"
            v-for="(item, index) in BillArray"
            :key="index"
          >
            <div class="time-data">
              {{ item.month | routeMonth }}
              <span class="time-desc">月待结算收益</span>
            </div>
            <div class="content">
              <span class="mtitle">广告收入</span>
              <span class="value">{{ item.ad }}元</span>
            </div>
            <div class="content">
              <span class="mtitle">贡献点收入</span>
              <span class="value">{{ item.contribution }}元</span>
            </div>
            <div class="content">
              <span class="mtitle">迷你点折算收入</span>
              <span class="value">{{ item.minipoint }}元</span>
            </div>
            <div class="content">
              <span class="mtitle">其他收入</span>
              <span class="value">{{ item.other }}元</span>
            </div>
            <div class="conclusion-box">
              <span class="conclusion">合计：</span>
              <span class="conclusion-value">
                <span class="conclusion-title">{{
                  (item.ad + item.other + item.contribution + item.minipoint)
                    | routeMoney
                }}</span>
                元
              </span>
            </div>
          </div>
          <div class="history-money" v-if="historyMoney">
            <span class="value">2022-01-01日前待结算收益</span>
            {{ historyMoney }}
            <span class="desc">元</span>
          </div>
        </div>
        <div class="sumbit" @click="closeDetailDialog">
          <el-button type="warning" size="medium">确认</el-button>
        </div>
        <div class="desc-bottom">
          <span class="desc">
            广告、贡献点、迷你点、其他收入自动根据兑换比例进行折算。详细请查看</span
          >
          <a
            href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
            target="_blank"
            >《迷你平台结算规则说明》</a
          >
        </div>
      </div>
    </el-dialog>
    <!-- 结算单寄送 -->
    <div class="dialog">
      <el-dialog
        :visible.sync="sendDisible"
        :destroy-on-close="true"
        class="send-dialog"
        width="668px"
        title="发票&结算单寄送"
      >
        <div class="detai-content">
          <div class="send-wrap">
            <div class="send-box">
              <div class="title">快递单号</div>
              <el-input type="input" v-model="courierNumber"></el-input>
            </div>
            <div class="send-box">
              <div class="title">寄件时间</div>
              <!-- <div class="textarea" v-model="courierTime">  </div> -->
              <div class="data-filter">
                <el-date-picker
                  v-model="courierTime"
                  type="date"
                  placeholder=""
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <div class="desc">
            <a
              href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
              target="_blank"
              >查看寄送说明</a
            >
          </div>
          <div class="submit-wrap">
            <div class="submit1" @click="cancel">取消</div>
            <div class="submit2" @click="clickSend">确定</div>
          </div>
        </div>
      </el-dialog>
      <!--确认账单弹框-->
      <studioFormDialog
        :showWithdrawForm="showWithdrawForm2"
        :withdrawInfo="drawInfo"
        @closeWithdrawForm="closedrawForm"
      >
      </studioFormDialog>
    </div>
  </div>
</template>
<script>
import studioFormDialog from '../withdraw/studioDialog.vue';
import FormDialog from '../withdraw/formDialog.vue';
const ONE_DAY = 24 * 60 * 60 - 1;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
import {
  fetchIncomeView,
  fetchSettleData,
  fetchOverview,
  fetchBillOk,
  fetchBillReset,
  fetchBillSend,
  fetchBillIncome,
} from '@/api/income';
// import { getVercode } from '@/api/common';
let create_time = '';
export default {
  components: {
    studioFormDialog,
    FormDialog,
  },
  data() {
    return {
      money: 100,
      binding: true,
      canWithdraw: true,
      canMinibean: true,
      // openBillDialog: false,
      lookVisible: false,
      step: -1,
      sendDisible: false,
      showWithdrawForm1: false,
      showWithdrawForm2: false,
      canMoney: 0,
      courierNumber: '',
      description1: '待确认',
      description5: '',
      courierTime: '',
      sumMinibean: 0,
      order_id: '',
      conclusion_title: '',
      detailVisible: false,
      minibean_month_max: 0,
      totalCount: 0,
      minibean: 0,
      sumValue: 0,
      detailInfo: {},
      pickerOptions: {
        disabledDate(time) {
          let date =
            new Date(new Date(new Date()).toDateString()).getTime() +
            ONE_DAY_TIME;
          //可选择寄件时间： 大于订单创建时间且小于当前时间
          let time1 =
            new Date(new Date(new Date(time)).toDateString()).getTime() +
            ONE_DAY_TIME;
          return new Date(time).getTime() > date || time1 < create_time * 1000;
        },
      },
      stepArr: [
        {
          content: '确认账单金额',
        },
        {
          content: '邮寄发票&结算单',
        },
        {
          content: '平台签收',
        },
        {
          content: '平台审核',
        },
        {
          content: '打款完成',
        },
      ],
      ArrValue: [
        {
          title: '广告',
          value: 0,
        },
        {
          title: '贡献点',
          value: 0,
        },
        {
          title: '迷你点',
          value: 0,
        },
        {
          title: '迷你豆',
          value: 0,
        },
        {
          title: '其他收入',
          value: 0,
        },
      ],
      BillArray: [],
      settleArr: [],
      pagePagination: {
        page: 1,
        page_size: 2,
      },
      withdrawInfo: {},
      drawInfo: {},
      historyMoney: 0,
    };
  },
  created() {
    this.init();
    this.getInomeView();
    this.getSettleDetail();
  },
  watch: {
    step(val) {
      if (val == 0) {
        this.description = '待确认';
        this.sendTion = '';
      } else if (val == 2) {
        this.description = this.getDateString();
        this.sendTion = '';
      } else {
        this.description = this.getDateString();
        this.sendTion = this.getDateString();
      }
    },
  },
  filters: {
    regroupDate(timestamp) {
      let time = new Date(timestamp * 1000);
      let year = time.getFullYear();
      const month = (time.getMonth() + 1).toString().padStart(2, '0');
      const date = time.getDate().toString().padStart(2, '0');
      return year + '-' + month + '-' + date;
    },
    routeMonth(time) {
      time.toString();
      let year = time.toString().slice(0, 4);
      let month = time.toString().slice(4);
      let result = year + '-' + month;
      return result;
    },
    routeMoney(money) {
      return money.toFixed(2);
    },
  },
  methods: {
    init() {
      this.conclusion_title =
        this.ArrValue[0].value +
        '+' +
        this.ArrValue[1].value +
        '+' +
        (this.ArrValue[2].value + '/' + 500) +
        '+' +
        this.ArrValue[4].value +
        '=';
      //初始化寄送时间
      this.courierTime = new Date(
        new Date(new Date()).toDateString(),
      ).getTime();
    },
    PageChange(currPage) {
      this.pagePagination.page = currPage;
      this.getSettleDetail();
    },
    closeWithdrawForm(val) {
      this.showWithdrawForm1 = val;
    },
    closedrawForm(val) {
      this.showWithdrawForm2 = val;
      //刷新订单对公结算
      this.getSettleDetail();
    },
    closeDetailDialog() {
      this.detailVisible = false;
    },
    //提现迷你豆，根据传入数据不同区分
    getMinibean() {
      this.showWithdrawForm1 = true;
      this.withdrawInfo.num = this.minibean;
      this.withdrawInfo.type = 2;
    },
    //获取迷你豆
    async getInomeView() {
      try {
        const res = await fetchIncomeView({ dtype: 2 });
        this.minibean = res.data.minibean;
        this.minibean_month_max = res.data.minibean_month_max;
        if (this.minibean > 0) {
          this.canMinibean = true;
        } else {
          this.canMinibean = false;
        }
      } catch (error) {
        console.error();
      }
    },
    //对公结算
    async getSettleDetail() {
      try {
        let data = {
          page: this.pagePagination.page,
          page_size: this.pagePagination.page_size,
        };
        const res = await fetchSettleData(data);
        this.settleArr = res.data.list;
        this.totalCount = res.data.total_count;
        //this.stepArr[0].date=
      } catch (error) {
        console.log(error);
      }
    },
    //点击完成订单
    async closeCommit(id) {
      try {
        await fetchBillOk({
          id: id,
        });
        this.getSettleDetail();
      } catch (error) {
        console.log(error);
      }
    },
    //重新发起流程
    async sendGinCommit(id) {
      try {
        await fetchBillReset({
          id: id,
        });
        this.getSettleDetail();
      } catch (error) {
        console.log(error);
      }
    },
    cancel() {
      this.sendDisible = false;
    },
    clickSend() {
      //对快递单号进行正则判断
      // <!--1-20位数字加字母-->
      let reg1 = new RegExp('^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{0,20}$');
      // <!--1-20位数字>
      let reg2 = new RegExp('^[0-9]{0,20}$');
      if (!this.courierNumber) {
        this.$message.error('快递单号不能为空');
      } else if (
        !reg1.test(this.courierNumber) &&
        !reg2.test(this.courierNumber)
      ) {
        this.$message.error('快递单号长度不超过20，且由数字或数字加英文组成');
      } else {
        this.sendDisible = false;
        this.sendBill();
      }

      //this.
    },
    //发票寄送
    async sendBill() {
      //寄送时间固定当天
      this.courierTime = new Date(
        new Date(new Date()).toDateString(),
      ).getTime();
      try {
        let data = {
          email_id: this.courierNumber,
          email_time: parseInt(
            new Date(this.courierTime).getTime() / 1000 + ONE_DAY,
            10,
          ),
          order_id: this.order_id,
        };
        await fetchBillSend(data);
        this.getSettleDetail();
      } catch (error) {
        console.log(error);
      }
    },
    // 确认寄送
    sendCommit(id, time) {
      this.courierNumber = '202123564264';
      //  this.sendDisible = true;
      create_time = time;
      this.order_id = id;
      this.sendBill();
    },
    // 下载结算单
    async downloadBill() {
      try {
        const res = await fetchOverview();
        this.downloadFile(res.data.url);
        this.$message.success('结算单下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    //点击查看明细
    clickStep(id) {
      this.getDetailData(id);
      this.detailVisible = true;
    },
    //获取订单明细数据
    async getDetailData(id) {
      //清空BillArray

      try {
        this.BillArray = [];
        this.historyMoney = 0;
        const res = await fetchBillIncome({ id: id });
        //判断是否存在历史遗留金额
        if (res.data.list.length) {
          res.data.list.map(item => {
            if (item.month === 202200) {
              this.historyMoney = item.wallet;
            } else {
              this.BillArray.push(item);
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    clickDetail() {
      this.lookVisible = true;
      this.getDataList();
    },
    //确认账单
    changeStep(money, time) {
      this.showWithdrawForm2 = true;
      this.drawInfo.num = money;
      create_time = time;
      this.drawInfo.type = 1;
    },
    // async fetchMoney() {
    //   await getVercode();
    //   let data = {
    //     vercode: 111111,
    //     money: this.minibean_month_max,
    //     money_type: 1
    //   };
    //   await withdraw(data);
    // },
    getMoney() {
      this.showWithdrawForm1 = true;
    },
    getDateString() {
      let year = new Date().getFullYear();
      let month =
        new Date().getMonth() + 1 < 10
          ? '0' + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let day =
        new Date().getDate() < 10
          ? '0' + new Date().getDate()
          : new Date().getDate();
      return year + '-' + month + '-' + day;
    },
    //获取收益概览数据
    async getDataList() {},
  },
};
</script>
<style lang="scss" scoped>
.wrapdraw-wrapper {
  .announcement {
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    display: flex;
    padding: 10px 6px;
    align-items: center;
    .annocedesc {
      vertical-align: middle;
    }
    .click-detail {
      margin-left: 70px;
      margin-right: 10px;
      padding: 3px 6px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
    }
    .click-annoce {
      padding: 3px 6px;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      cursor: pointer;
      a {
        color: #262626;
        text-decoration: none;
      }
    }
  }

  .wrapdraw-box {
    margin: 20px 32px 42px 32px;
    padding: 13px 42px 12px 28px;
    //height: 130px;
    border: 1px solid #e8edf7;
    background: #fcfdff;
    border-radius: 4px;
    font-size: 16px;
    .content-wrap {
      display: flex;
      align-items: center;
      .content {
        display: flex;
        flex: 1;
        .desc {
          padding-top: 12px;
          margin-left: 14px;
          font-size: 20px;
          color: #000000;
        }
        .desc1 {
          padding-top: 18px;
          margin-left: 14px;
          font-size: 20px;
          color: #000000;
        }
        .imgPic {
          height: 52px;
          padding-top: 16px;
          width: 36px;
        }
        .el-tooltip {
          margin-top: 9px;
          margin-right: 18px;
        }
        .mValue {
          margin-left: 10px;
          color: #fd9b21;
          display: flex;
          .value1 {
            font-size: 32px;
          }
          .bean {
            font-size: 16px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 12px;
            margin-left: 6px;
          }
        }
        .mValue1 {
          margin-left: 10px;
          color: #fd9b21;
          padding-top: 6px;
          display: flex;
          .value1 {
            font-size: 32px;
          }
          .bean {
            font-size: 16px;
            display: flex;
            align-items: flex-end;
            padding-bottom: 6px;
            margin-left: 6px;
          }
        }
      }
      .bind {
        .button1.el-row {
          margin-top: 12px;
          border-radius: 4px;
          border: 1px solid #ffc973;
        }
        .button2.el-row {
          margin-top: 12px;
        }
        .el-button.el-button--warning {
          padding-top: 5px;
          text-align: center;
          padding-bottom: 4px;
          width: 134px;
          font-size: 18px;
          border: none;
          background: #fffaed;
          line-height: 25px;
          color: #fd9b21;
        }
        .el-button.el-button--warning.is-disabled {
          //ba
          background: #d9d9d9;
          color: #fffaed;
          border-color: none;
        }
      }
    }

    .intro {
      // margin-left: 5px;
      margin-left: 50px;
      margin-top: -14px;
      font-size: 14px;
      color: #bfbfbf;
      line-height: 28px;
    }
  }
  .settlement-box {
    margin-left: 32px;
    .all-title {
      color: #262626;
      font-size: 18px;
      line-height: 24px;
      margin-bottom: 41px;
    }
    .settlement-wrap {
      // margin-bottom: 62px;
      .settle-description {
        height: 48px;
        margin-top: 24px;
        margin-bottom: 36px;
        margin-right: 32px;
        display: flex;
        background: #ffede9;
        padding-top: 15px;
        padding-left: 21px;
        padding-bottom: 14px;
        .label {
          background: #ff5533;
          border: 0;
          border-radius: 50%;
          width: 24px;
          height: 24px;
          margin: 0 3px;
          margin-top: -2px;
          display: flex;
          justify-content: center;
          align-items: center;
          .label-content {
            width: 12px;
            height: 10px;
            margin: auto;
            position: relative;
            margin-left: 31px;
          }
          .label-content::before,
          .label-content::after {
            content: '';
            position: absolute;
            height: 11px;
            width: 1.9px;
            top: 0px;
            right: 15px;
            background: #ffffff;
          }
          .label-content::before {
            transform: rotate(45deg);
          }
          .label-content::after {
            transform: rotate(-45deg);
          }
        }
        .content {
          margin-left: 15px;
          color: #595959;
          font-size: 14px;
        }
      }
    }
    .data-filter {
      display: flex;
      justify-content: center;
      padding-top: 38px;
      padding-bottom: 50px;
      ::v-deep .btn-prev {
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
      }
      ::v-deep .btn-prev:disabled {
        color: #8c8c8c;
      }
      ::v-deep .number.active {
        background-color: #fffaed;
        border: 1px solid #ffc973;
        color: #fd9b21;
      }
      ::v-deep .btn-next {
        background-color: #ffffff;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
      }
      ::v-deep .btn-next:disabled {
        color: #8c8c8c;
      }
      ::v-deep .el-pagination__jump {
        margin-left: 28px;
      }
      ::v-deep .el-pagination__editor.el-input {
        width: 47px;
        margin-left: 6px;
        margin-right: 6px;
      }
    }
    .intro-wrap {
      .title {
        color: #262626;
        font-size: 18px;
        margin-bottom: 22px;
      }
      .desc {
        font-size: 14px;
        line-height: 18px;
        color: #8c8c8c;
        margin-bottom: 12px;
      }
      .desc-bottom {
        color: #262626;
        a {
          text-decoration: none;
          color: #fd9b21;
        }
      }
      margin-bottom: 600px;
    }
    .content {
      display: flex;

      .desc {
        line-height: 21px;
        font-size: 16px;
        color: #595959;
      }
      .mValue {
        font-size: 16px;
        display: flex;
        margin-left: -4px;
        color: #fd9b21;
        align-items: flex-start;
        .value1 {
          font-size: 32px;
          line-height: 42px;
          margin-top: -12px;
          margin-right: 6px;
        }
      }
    }
    .withdraw-step {
      .step-wrap {
        display: flex;
        margin-bottom: 30px;
        padding: 0 30px 0 60px;
        .steps {
          .steps-label {
            display: flex;
            align-items: center;
            .label {
              width: 24px;
              height: 24px;
              margin: 0 3px;
              background: #ffffff;
              border: 2px solid #ffc973;
              border-radius: 50%;
            }
            .step-line {
              width: 187px;
              height: 4px;
              background: #fd9b21;
              border-radius: 4px 0px 0px 4px;
            }
          }
          .active.steps-label {
            .label {
              background: #18d125;
              border: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              .label-content {
                width: 15px;
                height: 8px;
                margin-bottom: 4px;
                border: 3px solid #ffffff;
                border-radius: 1px;
                border-top-width: 0px;
                border-right-width: 0px;
                background-color: rgba(0, 0, 0, 0);
                transform: rotate(-45deg);
              }
            }
            .step-line {
              background: #18d125;
            }
          }
          .fail.steps-label {
            .label {
              background: #ff5533;
              border: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              .label-content {
                width: 12px;
                height: 10px;
                margin: auto;
                position: relative;
                margin-left: 31px;
              }
              .label-content::before,
              .label-content::after {
                content: '';
                position: absolute;
                height: 11px;
                width: 1.9px;
                top: 0px;
                right: 15px;
                background: #ffffff;
              }
              .label-content::before {
                transform: rotate(45deg);
              }
              .label-content::after {
                transform: rotate(-45deg);
              }
            }
            .step-line {
              background: #fd9b21;
            }
          }
          .step-content {
            display: flex;
            flex-direction: column;
            .content {
              display: flex;
              color: #262626;
              font-size: 14px;
              margin-left: -12px;
              margin-top: 18px;
              margin-right: -30px;
            }
            .content-fail {
              font-size: 14px;
              color: #ff5533;
              margin-top: 6px;
              margin-left: -5px;
              line-height: 19px;
            }
            .date {
              margin-top: 6px;
              color: #595959;
              font-size: 14px;
              margin-left: -22px;
            }
            .date1 {
              margin-top: 6px;
              color: #595959;
              font-size: 14px;
              margin-left: -8px;
            }
            .date2 {
              margin-top: 6px;
              color: #595959;
              font-size: 14px;
              margin-left: -10px;
            }
            .date3 {
              margin-top: 6px;
              margin-left: -5px;
              color: #595959;
              font-size: 14px;
            }
          }
        }
        .steps:first-child {
          .step-content {
            .content {
              margin-left: -28px;
            }
          }
        }
        .steps:nth-child(2) {
          .step-content {
            .content {
              margin-left: -40px;
            }
          }
        }
      }
      margin-top: 49px;
      margin-left: -35px;
      ::v-deep.el-step__head.is-process {
        color: #c0c4cc;
        border-color: #c0c4cc;
      }
      ::v-deep.el-step__title.is-process {
        color: #c0c4cc;
      }
      ::v-deep.el-step__description.is-finish {
        // margin-top: -90px;
        font-size: 14px;
      }
      ::v-deep.el-step__description.is-process {
        // margin-top: -90px;
        font-size: 14px;
      }
    }
    .submit-step {
      display: flex;
      margin-top: 46px;
      margin-bottom: 62px;
      justify-content: flex-end;
      margin-right: 50px;
      .button1 {
        padding: 10px 20px;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
        color: #262626;
        font-size: 20px;
        cursor: pointer;
        margin-left: 40px;
      }
      .button2 {
        background: #fd9b21;
        padding: 10px 20px;
        margin-left: 40px;
        border-radius: 8px;
        font-size: 20px;
        cursor: pointer;
        color: #ffffff;
      }
      //margin-right: 50px;
    }
  }
  .el-dialog__wrapper.detail-dialog {
    ::v-deep .el-dialog__header {
      padding: 0;
      padding-top: 40px;
      text-align: center;
      .el-dialog__title {
        color: #262626;
        font-size: 24px;
      }
    }
    ::v-deep .el-dialog__body {
      padding: 32px 14px 24px 115px;

      .detail-content {
        .detail-box {
          height: 480px;
          overflow-y: scroll;
          &::-webkit-scrollbar {
            width: 6px;
          }
          /*定义滚动条的轨道颜色、内阴影及圆角*/
          &::-webkit-scrollbar-track {
            // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
            background-color: #ffffff;
          }
          /*定义滑块颜色、内阴影及圆角*/
          &::-webkit-scrollbar-thumb {
            border-radius: 3px;
            height: 60px;
            background: #e5e5e5;
          }
        }

        .sumbit {
          display: flex;
          justify-content: center;
          margin-top: 11px;
          margin-right: 85px;
          margin-bottom: 24px;
          .el-button--medium {
            // width: 160px;
            // height: 46px;
            border-radius: 8px;
            font-size: 20px;
            padding: 8px 59px;
            color: #ffffff;
          }
          .el-button--warning {
            background-color: #fd9b21;
            border-color: none;
            color: #ffffff;
          }
        }
        .desc-bottom {
          text-align: center;
          margin-right: 85px;
          .desc {
            font-size: 16px;
          }
          a {
            text-decoration: none;
            font-size: 16px;
            color: #2b6ddf;
          }
        }
        .detail-wrap {
          margin-bottom: 34px;
          margin-right: 114px;
          .time-data {
            margin-bottom: 24px;
            font-size: 24px;
            color: #262626;
            .time-desc {
              font-size: 18px;
            }
          }
          .content {
            color: #595959;
            font-size: 16px;
            margin-bottom: 14px;
            display: flex;
            .mtitle {
              display: flex;
              flex: 1;
            }
          }
          .conclusion-box {
            display: flex;
            color: #262626;
            .conclusion {
              display: flex;
              flex: 1;
              font-size: 24px;
            }
            .conclusion-value {
              font-size: 18px;
              .conclusion-title {
                font-size: 28px;
              }
            }
          }
        }
        .history-money {
          font-size: 28px;
          margin-top: -6px;
          color: #262626;
          display: flex;
          margin-right: 114px;
          .value {
            display: flex;
            flex: 1;
            font-size: 24px;
          }
          .desc {
            font-size: 18px;
            margin-left: 6px;
            margin-top: 10px;
          }
        }
      }
    }
  }
  .el-dialog__wrapper.send-dialog {
    ::v-deep .el-dialog__header {
      padding: 0;
      padding-top: 40px;
      text-align: center;
      .el-dialog__title {
        color: #262626;
        font-size: 24px;
      }
    }
    ::v-deep .el-dialog__body {
      padding: 0;
    }
  }
  .look-detail {
    ::v-deep.el-dialog__header {
      text-align: center !important;
      padding-bottom: 0px;
      .el-dialog__title {
        color: #262626;
        font-weight: 600;
      }
    }
    ::v-deep.el-dialog__body {
      padding-top: 20px;
    }
    .detail-content {
      color: #262626;
      .title {
        font-size: 18px;
        color: #262626;
        font-weight: 600;
      }
      .content {
        display: flex;
        font-size: 16px;
        padding-top: 8px;
        .mtitle {
          display: flex;
          flex: 1;
        }
      }
      .conclusion-box {
        font-size: 16px;
        margin-top: 20px;
      }
      .sumbit {
        margin-top: 20px;
        text-align: center;
        color: #262626;
        .el-button {
          width: 100px;
        }
      }
    }
  }
  .dialog {
    ::v-deep.el-dialog__header {
      // text-align: center;
      color: #262626;
      font-size: 24px;
      .el-dialog__headerbtn {
        display: none;
      }
    }
    ::v-deep.el-dialog__body {
      padding: 30px 20px;
    }
    .detai-content {
      .send-wrap {
        margin-top: 41px;
        .send-box {
          display: flex;
          margin-left: 81px;
          margin-right: 100px;
          align-items: center;
          .title {
            //margin-right: 29px;
            font-size: 16px;
            color: #262626;
            line-height: 28px;
            margin-right: 29px;
          }
          .el-input {
            width: 392px;
            height: 40px;
          }
        }
        .send-box:first-child {
          margin-bottom: 42px;
        }
      }
      .desc {
        float: right;
        margin: 24px 100px 0 0;
        color: #2b6ddf;
        font-size: 16px;
        cursor: pointer;
        a {
          text-decoration: none;
          color: #2b6ddf;
          font-size: 16px;
        }
      }
      .submit-wrap {
        margin-top: 78px;
        padding-bottom: 40px;
        display: flex;
        justify-content: center;
        .submit1 {
          background: #d9d9d9;
          border-radius: 8px;
          color: #ffffff;
          font-size: 20px;
          margin-right: 70px;
          cursor: pointer;
          padding: 10px 40px 8px 40px;
        }
        .submit2 {
          background: #fd9b21;
          border-radius: 8px;
          color: #ffffff;
          cursor: pointer;
          font-size: 20px;
          padding: 10px 40px 8px 40px;
        }
      }
    }
  }
}
</style>
